import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const selectOffer = createAction(
  '[Product Details] Select Offer',
  props<{ payload: ReplacementOffer }>()
);

export type SelectedActions = typeof selectOffer;
